import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, vModelText as _vModelText, withDirectives as _withDirectives, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createBlock as _createBlock, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("span", null, "Confirmar", -1)
const _hoisted_2 = [
  _hoisted_1
]
const _hoisted_3 = { class: "ant-row" }
const _hoisted_4 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_5 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_6 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_7 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_8 = {
  key: 0,
  class: "ant-col ant-col-xs-4 ant-col-xl-4"
}
const _hoisted_9 = {
  key: 1,
  class: "ant-col ant-col-xs-4 ant-col-xl-4"
}
const _hoisted_10 = { class: "ant-row" }
const _hoisted_11 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_12 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_13 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_14 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_15 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_16 = { class: "ant-row" }
const _hoisted_17 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_18 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_19 = { class: "ant-col ant-col-xs-8 ant-col-xl-8" }
const _hoisted_20 = { class: "ant-row" }
const _hoisted_21 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_22 = { class: "ant-row" }
const _hoisted_23 = { class: "ant-col ant-col-xs-12 ant-col-xl-12" }
const _hoisted_24 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_25 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_26 = { class: "ant-row" }
const _hoisted_27 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_28 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_29 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_30 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_31 = {
  key: 0,
  class: "ant-row"
}
const _hoisted_32 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_33 = { class: "ant-col ant-col-xs-6 ant-col-xl-6" }
const _hoisted_34 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_35 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_36 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("span", null, "Adicionar", -1)
const _hoisted_38 = [
  _hoisted_37
]
const _hoisted_39 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col",
    style: {"flex":"1 1 auto"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Tipo")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-5 ant-col-xl-5" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Comprovante de Entrega")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-4 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Recibo do Pagador")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-4 ant-col-xl-4" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Carnê")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-2 ant-col-xl-2" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações")
  ])
], -1)
const _hoisted_40 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_41 = { class: "ss-margin-campos ss-campo-descricao" }
const _hoisted_42 = { class: "ant-col ant-col-xs-5 ant-col-xl-5" }
const _hoisted_43 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_44 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_45 = { class: "ant-col ant-col-xs-2 ant-col-xl-2" }
const _hoisted_46 = { class: "ss-margin-campos" }
const _hoisted_47 = ["onClick"]
const _hoisted_48 = { class: "ant-row" }
const _hoisted_49 = { class: "ant-col ant-col-xs-20 ant-col-xl-20" }
const _hoisted_50 = { class: "ant-col ant-col-xs-4 ant-col-xl-4" }
const _hoisted_51 = /*#__PURE__*/_createElementVNode("span", null, "Adicionar", -1)
const _hoisted_52 = [
  _hoisted_51
]
const _hoisted_53 = /*#__PURE__*/_createElementVNode("div", { class: "ant-row ss-grade-personalizada-titulo" }, [
  /*#__PURE__*/_createElementVNode("div", {
    class: "ant-col",
    style: {"flex":"1 1 auto"}
  }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Mensagem")
  ]),
  /*#__PURE__*/_createElementVNode("div", { class: "ant-col ant-col-xs-3 ant-col-xl-3" }, [
    /*#__PURE__*/_createElementVNode("span", { class: "ss-titulo-campo" }, "Ações")
  ])
], -1)
const _hoisted_54 = {
  class: "ant-col",
  style: {"flex":"1 1 auto"}
}
const _hoisted_55 = { class: "ss-margin-campos ss-campo-descricao" }
const _hoisted_56 = ["value"]
const _hoisted_57 = { class: "ant-col ant-col-xs-3 ant-col-xl-3" }
const _hoisted_58 = { class: "ss-margin-campos" }
const _hoisted_59 = ["onClick"]
const _hoisted_60 = { class: "ant-row" }
const _hoisted_61 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_62 = { class: "ant-row" }
const _hoisted_63 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_64 = /*#__PURE__*/_createElementVNode("label", { class: "" }, "Assunto do E-mail de Cobrança", -1)
const _hoisted_65 = { style: {"width":"400px"} }
const _hoisted_66 = { class: "ant-row" }
const _hoisted_67 = { class: "ant-col ant-col-xs-24 ant-col-xl-24" }
const _hoisted_68 = /*#__PURE__*/_createElementVNode("label", { class: "" }, "Corpo do E-mail de Cobrança", -1)
const _hoisted_69 = { style: {"width":"400px"} }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_icone = _resolveComponent("icone")!
  const _component_selecionar_generico_string = _resolveComponent("selecionar-generico-string")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_selecionar_generico = _resolveComponent("selecionar-generico")!
  const _component_selecionar_tipo_layout_remessa = _resolveComponent("selecionar-tipo-layout-remessa")!
  const _component_a_tab_pane = _resolveComponent("a-tab-pane")!
  const _component_a_checkbox = _resolveComponent("a-checkbox")!
  const _component_selecionar_tipo_impressao_boletos = _resolveComponent("selecionar-tipo-impressao-boletos")!
  const _component_mensagem_sem_dados = _resolveComponent("mensagem-sem-dados")!
  const _component_selecionar_servidor_email_notificacao = _resolveComponent("selecionar-servidor-email-notificacao")!
  const _component_selecionar_variavel_cobranca = _resolveComponent("selecionar-variavel-cobranca")!
  const _component_a_popover = _resolveComponent("a-popover")!
  const _component_editor_html = _resolveComponent("editor-html")!
  const _component_a_tabs = _resolveComponent("a-tabs")!
  const _component_card = _resolveComponent("card")!
  const _component_a_form = _resolveComponent("a-form")!
  const _component_a_skeleton = _resolveComponent("a-skeleton")!
  const _component_a_modal = _resolveComponent("a-modal")!

  return (_openBlock(), _createBlock(_component_a_modal, {
    keyboard: false,
    visible: _ctx.modalBase.computedVisivel,
    "onUpdate:visible": _cache[36] || (_cache[36] = ($event: any) => ((_ctx.modalBase.computedVisivel) = $event)),
    style: {"width":"950px"},
    "wrap-class-name": "ss-modal-cadastros"
  }, {
    title: _withCtx(() => [
      _createTextVNode("Configuração de Boletos")
    ]),
    closeIcon: _withCtx(() => [
      _createVNode(_component_icone, { nome: "voltar" })
    ]),
    footer: _withCtx(() => [
      _createElementVNode("div", null, [
        _createElementVNode("button", {
          type: "button",
          class: "ant-btn ant-btn-lg ant-btn-primary ss-btn-acao-destaque",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.salvar && _ctx.salvar(...args)))
        }, _hoisted_2)
      ])
    ]),
    default: _withCtx(() => [
      _createVNode(_component_a_skeleton, {
        loading: _ctx.telaBase.carregando
      }, {
        default: _withCtx(() => [
          _createVNode(_component_a_form, { layout: "vertical" }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_3, [
                _createElementVNode("div", _hoisted_4, [
                  _createVNode(_component_card, null, {
                    default: _withCtx(() => [
                      _createVNode(_component_a_tabs, { defaultActiveKey: "1" }, {
                        default: _withCtx(() => [
                          _createVNode(_component_a_tab_pane, {
                            key: "1",
                            tab: "DADOS PRINCIPAIS"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.state.banco.codigoBanco !== '077')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                    _createElementVNode("div", _hoisted_6, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Espécie",
                                        class: "ss-margin-campos",
                                        rules: [{ required: true }]
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_generico_string, {
                                            itens: _ctx.state.especies,
                                            valor: _ctx.state.configuracao.especie,
                                            "onUpdate:valor": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.state.configuracao.especie) = $event))
                                          }, null, 8, ["itens", "valor"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_7, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Carteira",
                                        class: "ss-margin-campos",
                                        rules: [{ required: true }]
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_generico, {
                                            itens: _ctx.state.carteiras,
                                            valor: _ctx.state.configuracao.carteira,
                                            "onUpdate:valor": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.state.configuracao.carteira) = $event))
                                          }, null, 8, ["itens", "valor"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    (_ctx.state.banco.codigoBanco === '001')
                                      ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Variação da carteira",
                                            class: "ss-margin-campos",
                                            rules: [{ required: true }]
                                          }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "ant-input",
                                                "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.state.configuracao.variacaoCarteira) = $event))
                                              }, null, 512), [
                                                [_vModelText, _ctx.state.configuracao.variacaoCarteira]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                      : (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                          _createVNode(_component_a_form_item, {
                                            label: "Operação/Posto",
                                            class: "ss-margin-campos"
                                          }, {
                                            default: _withCtx(() => [
                                              _withDirectives(_createElementVNode("input", {
                                                type: "text",
                                                class: "ant-input",
                                                "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.state.configuracao.variacaoCarteira) = $event))
                                              }, null, 512), [
                                                [_vModelText, _ctx.state.configuracao.variacaoCarteira]
                                              ])
                                            ]),
                                            _: 1
                                          })
                                        ]))
                                  ]))
                                : _createCommentVNode("", true),
                              _createElementVNode("div", _hoisted_10, [
                                _createElementVNode("div", _hoisted_11, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Modalidade de Cobrança",
                                    class: "ss-margin-campos",
                                    rules: [{ required: true }]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_selecionar_generico, {
                                        itens: _ctx.state.modalidadesCobranca,
                                        valor: _ctx.state.configuracao.modalidadeCobranca,
                                        "onUpdate:valor": _cache[5] || (_cache[5] = ($event: any) => ((_ctx.state.configuracao.modalidadeCobranca) = $event))
                                      }, null, 8, ["itens", "valor"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_12, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Próximo Nosso Nº",
                                    class: "ss-margin-campos",
                                    rules: [{ required: true }]
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "ant-input",
                                        min: "0",
                                        type: "number",
                                        style: {"text-align":"right"},
                                        "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_ctx.state.configuracao.proximoNossoNumero) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.configuracao.proximoNossoNumero]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_13, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Seq. Remessa",
                                    class: "ss-margin-campos",
                                    rules: [{ required: true }]
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "ant-input",
                                        min: "0",
                                        type: "number",
                                        style: {"text-align":"right"},
                                        "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.state.configuracao.sequenciaRemessa) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.configuracao.sequenciaRemessa]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_14, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Layout",
                                    class: "ss-margin-campos",
                                    rules: [{ required: true }]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_selecionar_tipo_layout_remessa, {
                                        valor: _ctx.state.configuracao.layoutRemessa,
                                        "onUpdate:valor": _cache[8] || (_cache[8] = ($event: any) => ((_ctx.state.configuracao.layoutRemessa) = $event))
                                      }, null, 8, ["valor"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_15, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Versão",
                                    class: "ss-margin-campos",
                                    rules: [{ required: true }]
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.state.configuracao.versaoRemessa) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.configuracao.versaoRemessa]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Código do Beneficiário",
                                    class: "ss-margin-campos",
                                    rules: [{ required: true }]
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "ant-input",
                                        type: "text",
                                        "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_ctx.state.configuracao.codigoBeneficiario) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.configuracao.codigoBeneficiario]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_18, [
                                  _createVNode(_component_a_form_item, {
                                    label: "DV",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "ant-input",
                                        type: "text",
                                        "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.state.configuracao.dvBeneficiario) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.configuracao.dvBeneficiario]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_19, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Código de Transmissão",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "ant-input",
                                        type: "text",
                                        "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_ctx.state.codigoTransmissao) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.codigoTransmissao]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "2",
                            tab: "DADOS DE COBRANÇA"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("div", _hoisted_21, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Tipo de Protesto",
                                    class: "ss-margin-campos",
                                    rules: [{ required: true }]
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_selecionar_generico, {
                                        itens: _ctx.state.codigosProtesto,
                                        valor: _ctx.state.configuracao.codigoProtesto,
                                        "onUpdate:valor": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.state.configuracao.codigoProtesto) = $event))
                                      }, null, 8, ["itens", "valor"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_22, [
                                _createElementVNode("div", _hoisted_23, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Local do Pagamento",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "ant-input",
                                        type: "text",
                                        "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_ctx.state.configuracao.localPagamento) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.configuracao.localPagamento]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_24, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Dias para Dev/Baixa",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "ant-input",
                                        min: "0",
                                        type: "number",
                                        "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.state.configuracao.diasDevolucao) = $event)),
                                        rules: [{ required: true }]
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.configuracao.diasDevolucao]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_25, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Dias para Protesto/Negativar",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        class: "ant-input",
                                        min: "0",
                                        type: "number",
                                        "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((_ctx.state.configuracao.diasProtestar) = $event)),
                                        rules: [{ required: true }]
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.configuracao.diasProtestar]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_26, [
                                _createElementVNode("div", _hoisted_27, [
                                  _createVNode(_component_a_form_item, {
                                    label: " ",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_checkbox, {
                                        class: "ss-margin-campos",
                                        checked: _ctx.state.configuracao.gerarMulta,
                                        "onUpdate:checked": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.state.configuracao.gerarMulta) = $event))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Gerar Multa")
                                        ]),
                                        _: 1
                                      }, 8, ["checked"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_28, [
                                  _createVNode(_component_a_form_item, {
                                    label: " ",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_checkbox, {
                                        class: "ss-margin-campos",
                                        checked: _ctx.state.configuracao.gerarJuros,
                                        "onUpdate:checked": _cache[18] || (_cache[18] = ($event: any) => ((_ctx.state.configuracao.gerarJuros) = $event))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Gerar Juros")
                                        ]),
                                        _: 1
                                      }, 8, ["checked"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_29, [
                                  _createVNode(_component_a_form_item, {
                                    label: " ",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_checkbox, {
                                        class: "ss-margin-campos",
                                        checked: _ctx.state.configuracao.gerarDesconto,
                                        "onUpdate:checked": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.state.configuracao.gerarDesconto) = $event))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Gerar Desconto")
                                        ]),
                                        _: 1
                                      }, 8, ["checked"])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_30, [
                                  _createVNode(_component_a_form_item, {
                                    label: " ",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_a_checkbox, {
                                        class: "ss-margin-campos",
                                        checked: _ctx.state.configuracao.aceite,
                                        "onUpdate:checked": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.state.configuracao.aceite) = $event))
                                      }, {
                                        default: _withCtx(() => [
                                          _createTextVNode("Aceite")
                                        ]),
                                        _: 1
                                      }, 8, ["checked"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "3",
                            tab: "DEFINIÇÕES DE IMPRESSÃO"
                          }, {
                            default: _withCtx(() => [
                              (_ctx.state.impressao.tipo !== 0)
                                ? (_openBlock(), _createElementBlock("div", _hoisted_31, [
                                    _createElementVNode("div", _hoisted_32, [
                                      _createVNode(_component_a_form_item, {
                                        label: "Tipo de Impressão",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_selecionar_tipo_impressao_boletos, {
                                            ignorarTipos: _ctx.state.tiposImpressaoUsados,
                                            valor: _ctx.state.impressao.tipo,
                                            "onUpdate:valor": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.state.impressao.tipo) = $event))
                                          }, null, 8, ["ignorarTipos", "valor"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_33, [
                                      _createVNode(_component_a_form_item, {
                                        label: " ",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_checkbox, {
                                            checked: _ctx.state.impressao.comprovanteEntrega,
                                            "onUpdate:checked": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.state.impressao.comprovanteEntrega) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Comprovante de Entrega")
                                            ]),
                                            _: 1
                                          }, 8, ["checked"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_34, [
                                      _createVNode(_component_a_form_item, {
                                        label: " ",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_checkbox, {
                                            checked: _ctx.state.impressao.reciboPagador,
                                            "onUpdate:checked": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.state.impressao.reciboPagador) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Recibo do Pagador")
                                            ]),
                                            _: 1
                                          }, 8, ["checked"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_35, [
                                      _createVNode(_component_a_form_item, {
                                        label: " ",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_a_checkbox, {
                                            checked: _ctx.state.impressao.carne,
                                            "onUpdate:checked": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.state.impressao.carne) = $event))
                                          }, {
                                            default: _withCtx(() => [
                                              _createTextVNode("Carnê")
                                            ]),
                                            _: 1
                                          }, 8, ["checked"])
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    _createElementVNode("div", _hoisted_36, [
                                      _createVNode(_component_a_form_item, {
                                        label: " ",
                                        class: "ss-margin-campos"
                                      }, {
                                        default: _withCtx(() => [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "ant-btn ant-btn-secondary",
                                            style: {"width":"100%"},
                                            onClick: _cache[25] || (_cache[25] = 
//@ts-ignore
(...args) => (_ctx.adicionarImpressao && _ctx.adicionarImpressao(...args)))
                                          }, _hoisted_38)
                                        ]),
                                        _: 1
                                      })
                                    ])
                                  ]))
                                : _createCommentVNode("", true),
                              _hoisted_39,
                              (_ctx.state.configuracao.impressoes.length <= 0)
                                ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                    key: 1,
                                    mensagem: "Nenhuma definição de impressão adicionada ainda"
                                  }))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 2 }, _renderList(_ctx.state.configuracao.impressoes, (impressao, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "ant-row ss-grade-personalizada-linha",
                                      key: index
                                    }, [
                                      _createElementVNode("div", _hoisted_40, [
                                        _createElementVNode("div", _hoisted_41, [
                                          _createVNode(_component_selecionar_tipo_impressao_boletos, {
                                            valor: impressao.tipo,
                                            "onUpdate:valor": ($event: any) => ((impressao.tipo) = $event),
                                            disabled: ""
                                          }, null, 8, ["valor", "onUpdate:valor"])
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_42, [
                                        _createElementVNode("span", null, _toDisplayString(impressao.comprovanteEntrega ? 'Imprimir' : 'Não Imprimir'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_43, [
                                        _createElementVNode("span", null, _toDisplayString(impressao.reciboPagador ? 'Imprimir' : 'Não Imprimir'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_44, [
                                        _createElementVNode("span", null, _toDisplayString(impressao.carne ? 'Imprimir' : 'Não Imprimir'), 1)
                                      ]),
                                      _createElementVNode("div", _hoisted_45, [
                                        _createElementVNode("div", _hoisted_46, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "ant-btn ant-btn-secondary ss-botao-remover",
                                            style: {"width":"100%"},
                                            title: "Remover",
                                            onClick: ($event: any) => (_ctx.removerImpressao(index))
                                          }, [
                                            _createVNode(_component_icone, {
                                              class: "ss-icone-remover",
                                              nome: "excluir"
                                            })
                                          ], 8, _hoisted_47)
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "4",
                            tab: "MENSAGENS"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_48, [
                                _createElementVNode("div", _hoisted_49, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Mensagem",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => ((_ctx.state.mensagem) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.mensagem]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ]),
                                _createElementVNode("div", _hoisted_50, [
                                  _createVNode(_component_a_form_item, {
                                    label: " ",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createElementVNode("button", {
                                        type: "button",
                                        class: "ant-btn ant-btn-secondary",
                                        style: {"width":"100%"},
                                        onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.adicionarMensagem && _ctx.adicionarMensagem(...args)))
                                      }, _hoisted_52)
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _hoisted_53,
                              (_ctx.state.configuracao.mensagens.length <= 0)
                                ? (_openBlock(), _createBlock(_component_mensagem_sem_dados, {
                                    key: 0,
                                    mensagem: "Nenhuma mensagem adicionada ainda"
                                  }))
                                : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.state.configuracao.mensagens, (mensagem, index) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "ant-row ss-grade-personalizada-linha",
                                      key: index
                                    }, [
                                      _createElementVNode("div", _hoisted_54, [
                                        _createElementVNode("div", _hoisted_55, [
                                          _createElementVNode("input", {
                                            type: "text",
                                            class: "ant-input",
                                            value: mensagem.mensagem,
                                            disabled: ""
                                          }, null, 8, _hoisted_56)
                                        ])
                                      ]),
                                      _createElementVNode("div", _hoisted_57, [
                                        _createElementVNode("div", _hoisted_58, [
                                          _createElementVNode("button", {
                                            type: "button",
                                            class: "ant-btn ant-btn-secondary ss-botao-remover",
                                            style: {"width":"100%"},
                                            title: "Remover",
                                            onClick: ($event: any) => (_ctx.removerMensagem(index))
                                          }, [
                                            _createVNode(_component_icone, {
                                              class: "ss-icone-remover",
                                              nome: "excluir"
                                            })
                                          ], 8, _hoisted_59)
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_a_tab_pane, {
                            key: "5",
                            tab: "E-MAIL DE COBRANÇA"
                          }, {
                            default: _withCtx(() => [
                              _createElementVNode("div", _hoisted_60, [
                                _createElementVNode("div", _hoisted_61, [
                                  _createVNode(_component_a_form_item, {
                                    label: "Servidor de E-mail de Notificação",
                                    class: "ss-margin-campos"
                                  }, {
                                    default: _withCtx(() => [
                                      _createVNode(_component_selecionar_servidor_email_notificacao, {
                                        empresas: [_ctx.state.configuracao.codigoEmpresa],
                                        codigoSelecionado: _ctx.state.configuracao.codigoServidorEmailNotificacao,
                                        "onUpdate:codigoSelecionado": _cache[28] || (_cache[28] = ($event: any) => ((_ctx.state.configuracao.codigoServidorEmailNotificacao) = $event))
                                      }, null, 8, ["empresas", "codigoSelecionado"])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_62, [
                                _createElementVNode("div", _hoisted_63, [
                                  _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                    label: _withCtx(() => [
                                      _hoisted_64,
                                      _createVNode(_component_a_popover, {
                                        placement: "top",
                                        title: "Adicionar Variável",
                                        trigger: "click"
                                      }, {
                                        content: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_65, [
                                            _createVNode(_component_selecionar_variavel_cobranca, {
                                              valor: _ctx.state.variavelSelecionada,
                                              "onUpdate:valor": _cache[29] || (_cache[29] = ($event: any) => ((_ctx.state.variavelSelecionada) = $event))
                                            }, null, 8, ["valor"]),
                                            _createElementVNode("button", {
                                              class: "ant-btn ant-btn-secondary",
                                              onClick: _cache[30] || (_cache[30] = 
//@ts-ignore
(...args) => (_ctx.adicionarVariavelAssunto && _ctx.adicionarVariavelAssunto(...args)))
                                            }, "Adicionar")
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_icone, {
                                            class: "ss-icone-informacao-campo",
                                            nome: "informacoes-fp"
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _withDirectives(_createElementVNode("input", {
                                        type: "text",
                                        class: "ant-input",
                                        maxlength: "250",
                                        "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => ((_ctx.state.configuracao.assuntoEmailCobranca) = $event))
                                      }, null, 512), [
                                        [_vModelText, _ctx.state.configuracao.assuntoEmailCobranca]
                                      ])
                                    ]),
                                    _: 1
                                  })
                                ])
                              ]),
                              _createElementVNode("div", _hoisted_66, [
                                _createElementVNode("div", _hoisted_67, [
                                  _createVNode(_component_a_form_item, { class: "ss-margin-campos" }, {
                                    label: _withCtx(() => [
                                      _hoisted_68,
                                      _createVNode(_component_a_popover, {
                                        placement: "top",
                                        title: "Adicionar Variável",
                                        trigger: "click"
                                      }, {
                                        content: _withCtx(() => [
                                          _createElementVNode("div", _hoisted_69, [
                                            _createVNode(_component_selecionar_variavel_cobranca, {
                                              valor: _ctx.state.variavelSelecionada,
                                              "onUpdate:valor": _cache[32] || (_cache[32] = ($event: any) => ((_ctx.state.variavelSelecionada) = $event))
                                            }, null, 8, ["valor"]),
                                            _createElementVNode("button", {
                                              class: "ant-btn ant-btn-secondary",
                                              onClick: _cache[33] || (_cache[33] = 
//@ts-ignore
(...args) => (_ctx.adicionarVariavelCorpo && _ctx.adicionarVariavelCorpo(...args)))
                                            }, "Adicionar")
                                          ])
                                        ]),
                                        default: _withCtx(() => [
                                          _createVNode(_component_icone, {
                                            class: "ss-icone-informacao-campo",
                                            nome: "informacoes-fp"
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]),
                                    default: _withCtx(() => [
                                      _createVNode(_component_editor_html, {
                                        value: _ctx.state.configuracao.corpoEmailCobranca,
                                        "onUpdate:value": _cache[34] || (_cache[34] = ($event: any) => ((_ctx.state.configuracao.corpoEmailCobranca) = $event))
                                      }, null, 8, ["value"]),
                                      _createElementVNode("button", {
                                        class: "ant-btn ant-btn-secondary",
                                        onClick: _cache[35] || (_cache[35] = 
//@ts-ignore
(...args) => (_ctx.restaurarTemplateEmail && _ctx.restaurarTemplateEmail(...args)))
                                      }, "Restaurar Modelo Padrão")
                                    ]),
                                    _: 1
                                  })
                                ])
                              ])
                            ]),
                            _: 1
                          })
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ])
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["loading"])
    ]),
    _: 1
  }, 8, ["visible"]))
}